import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        nextPant: false,
        screens: [0, 0],
        tema: '',
        subTema: '',
        // cantPagsMods: {moduloUno: 1, moduloDos: 30, moduloTres: 53, moduloCuatro: 74},
        cantPagsMods: [1,1,6,12,11,9], //Las dos primeras son para el landing page y la selección de los módulos
        paginas: 0,
        title: 'Introducción',
        mapStateM2: 0
      },
      mutations: {
        setTitle (state, newTitle) {
          state.title = newTitle
        },
        nextShow: (state, event) => state.nextPant = event,
        screenTrack: (state, [currentScr, cantScr]) => state.screens = [currentScr, cantScr],
        temaName: (state, event) => state.tema = event,
        subTemaName: (state, event) => state.subTema = event,
        conteoPaginas: (state, event) => state.paginas = event,
        updateMapStateM2: (state, event) => state.mapStateM2 = event
      },
      getters: {
        /* Retorna el número global de la página, este se compone de la suma de la 
          cantidad de páginas de todos los módulos anteriores y el modulo por el que se pregunta*/
    
        globalPage:(state) => (modNum) => {
          var page = 0;      
          for(var i = 0; i <= modNum; i++){
            page += state.cantPagsMods[i]
          }
          return page;
        }
    }
})
